var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 20",
    width: 32,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 3,
    fill: "#1434CB"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 13.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 8,
    fontWeight: 700,
    fontStyle: "italic",
    fill: "#fff",
    textAnchor: "middle",
    letterSpacing: 0.5
  }, "VISA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCardVisa);
export default __webpack_public_path__ + "static/media/logo-card-visa.75148611290d45d525d5437e808c3353.svg";
export { ForwardRef as ReactComponent };